import { createRouter, createWebHistory } from 'vue-router'
import shareds from '@/assets/js/shared'
const shared = new shareds()
const routes = [
    {
        path:'',
        name:'',
        redirect: { path: '/user' },
        component: () => import(/* webpackChunkName: "about" */ '@/views/landingPage.vue')
    },
    {
        path:'/user',
        name:'mainLayout',
        component: () => import(/* webpackChunkName: "about" */ '@/views/public/mainLayoutView.vue'),
        children:[{
            path:'',
            name:'empty',
            // redirect: { path: '/login/4' },
            component: () => import(/* webpackChunkName: "about" */ '@/views/public/empty.vue'),
            props: { message: '' }
        },
        {
            path:'/login/:com_type',
            name:'login',
            component: () => import(/* webpackChunkName: "about" */ '@/views/login/loginView.vue')
        },{
            path:'/register/:com_type',
            name:'register',
            component: () => import(/* webpackChunkName: "about" */ '@/views/register/registerView.vue')
        },{
            path:'/forgetPassword/:com_type',
            name:'forgetPassword',
            component: () => import(/* webpackChunkName: "about" */ '@/views/fgpwd/fgpwdView.vue')
        },{
            path:'/registerInvite/:com_type/:token',
            name:'registerInvite',
            component: () => import(/* webpackChunkName: "about" */ '@/views/register/registerInviteView.vue')
        },{
            path:'/logout/:com_type',
            name:'logout',
            component: () => import(/* webpackChunkName: "about" */ '@/views/login/logout.vue')
        }
        // ,{
        //     path:'/admin',
        //     name:'adminLoginView',
        //     component: () => import(/* webpackChunkName: "about" */ '../views/login/adminloginView.vue')
        // },
        ]
    },{
        path:'/registerNewCompany/:com_type',
        name:'registerNewCompany',
        component: () => import(/* webpackChunkName: "about" */ '@/views/register/registerNewCompanyView.vue')
    },{
        path:'/privacyPolicy',
        name:'privacyPolicy',
        component: () => import(/* webpackChunkName: "about" */ '@/views/privacyPolicy.vue')
    },{
        path:'/termsService',
        name:'termsService',
        component: () => import(/* webpackChunkName: "about" */ '@/views/termsService.vue')
    },{
        path: '/productCard/:code',
        name:'productCard',
        component: () => import(/* webpackChunkName: "about" */ '@/views/productCard.vue')
    },{
        path: '/emailVerify/:CV',
        name:'emailVerify',
        component: () => import(/* webpackChunkName: "about" */ '@/views/emailVerify.vue')
    }
    
]
let previousPath = null;
const router = createRouter({
    base: process.env.VUE_APP_BASE_APP_URL,
    history: createWebHistory(process.env.VUE_APP_BASE_APP_URL),
    routes,
    mode:'history',
    scrollBehavior(to, from, savedPosition) {
        // 滾動到最上方
        return { top: 0 };
    }
})

router.beforeEach((to, from, next) => {

    previousPath = from.fullPath; // 記錄前一個路由的 fullPath

    //處理是否登入過
    const isAuthenticated = !!shared.decryptionLocalStorageUserInfo(); // 或其他驗證機制
    if ( 
        ( 
            to.name === 'login' ||
            to.name === 'empty' 
        ) &&
        isAuthenticated
    ){
        const userData = shared.decryptionLocalStorageUserInfo()
        const url = `${shared.gotoSystemView(userData.com_type)}${encodeURIComponent(shared.encryptionUserInfo(userData))}`
        
        document.location.href = url
    }

    next();

});
export { router, previousPath }; // 匯出 previousPath，其他元件可讀取
export default router